import { defineStore } from 'pinia'
import axios from '@/services'

export const useBrandsStore = defineStore('brands', {
  modelName: 'Brand',
  state: () => ({
    brands: [],
    loading: false
  }),

  getters: {
    getAllBrands: (state) => state.brands,
    isLoading: (state) => state.loading,
    brandsCount: (state) => state.brands.length
  },

  actions: {
    onModelChanged() {
      this.getBrands()
    },

    async getBrands() {
      this.loading = true
      
      try {
        const response = await axios.get('/api/brands/getBrands')
        this.brands = response.data.data
      } catch (error) {
        console.error('Error fetching brands:', error)
        this.brands = []
      } finally {
        this.loading = false
      }
    },

    setBrands(brands) {
      this.brands = brands
    },

    setLoading(value) {
      this.loading = value
    }
  }
})